import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {CURRENT_CREDITORS_SEARCH_QUERY_KEY} from "../queryKeys";

type Variables = {q: string};
type Data = string[];

const searchCurrentCreditors = async (variables: Variables): Promise<Data> => {
  const response = await axiosReachInstance.get<Data, AxiosResponse<Data>>("/segments/current-creditors", {
    params: {q: variables.q},
  });
  return response.data;
};

export const useSearchCurrentCreditors = (
  variables: Variables,
  options?: BaseQueryOptions<Data, Variables>
): BaseUseQueryResult<Data> =>
  useBaseQuery<Data, Variables>(
    [CURRENT_CREDITORS_SEARCH_QUERY_KEY, variables.q],
    searchCurrentCreditors,
    variables,
    options
  );
